// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Trash2 } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconTrash2(props: any) {
    return <IconBase icon={Trash2} {...props} />
  }

  export default IconTrash2
  